import { ContentNodeUtils } from '../../ContentNode';
import { createRuntimeOperationType, isRecord, isRuntimeOperationConfig, } from './common';
export const setStateOperationType = createRuntimeOperationType({
    kind: 'SET_STATE',
    dependencies: () => [],
    run: (value, context) => {
        if (!Array.isArray(value)) {
            throw new Error(`SET_STATE value must be an array. Got ${JSON.stringify(value)}`);
        }
        if (value.length < 2) {
            return value;
        }
        const [firstValue, secondValue] = value;
        if (!isRecord(firstValue) || !('state' in firstValue)) {
            return firstValue;
        }
        if (isRuntimeOperationConfig(secondValue)) {
            return firstValue;
        }
        if (!isRecord(secondValue)) {
            return firstValue;
        }
        const updatedFirstValue = ContentNodeUtils.setState([secondValue])(firstValue);
        return updatedFirstValue;
    },
});
//# sourceMappingURL=set-state.js.map